import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiMapPin, FiTarget, FiHeart } from 'react-icons/fi';

const UeberUns = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* Hero */}
      <div className="bg-slate-50 py-20 border-b border-slate-100">
        <div className="container-custom max-w-4xl text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Über Nebenjob Nord</h1>
          <p className="text-xl text-slate-600">
            Nicht einfach nur Stellenanzeigen. Wir bringen Menschen und Unternehmen im Norden passend zusammen – persönlich, regional und unkompliziert.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="container-custom py-20">
        <div className="grid md:grid-cols-2 gap-16 items-center mb-24">
          <div>
            <h2 className="text-3xl font-bold mb-6">Unsere Mission</h2>
            <p className="text-lg text-slate-600 mb-4 leading-relaxed">
              Die Jobsuche für einfache Tätigkeiten ist oft unnötig kompliziert. Bewerber müssen lange Anschreiben verfassen, Unternehmen werden mit unpassenden Profilen überflutet. 
            </p>
            <p className="text-lg text-slate-600 leading-relaxed">
              <strong>Nebenjob Nord ändert das.</strong> Wir positionieren uns als regionaler Vermittler in Hamburg und Norddeutschland. Wir stehen dazwischen, filtern, matchen und sorgen dafür, dass beide Seiten schnell genau das finden, was sie suchen.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-teal-50 p-6 rounded-2xl text-center">
              <SafeIcon icon={FiTarget} className="text-3xl text-teal-600 mx-auto mb-3" />
              <h3 className="font-bold mb-1">Fokus</h3>
              <p className="text-sm text-slate-600">Minijobs & Aushilfen</p>
            </div>
            <div className="bg-blue-50 p-6 rounded-2xl text-center mt-8">
              <SafeIcon icon={FiMapPin} className="text-3xl text-blue-600 mx-auto mb-3" />
              <h3 className="font-bold mb-1">Regional</h3>
              <p className="text-sm text-slate-600">Norddeutschland</p>
            </div>
            <div className="bg-slate-100 p-6 rounded-2xl text-center -mt-8">
              <SafeIcon icon={FiHeart} className="text-3xl text-slate-700 mx-auto mb-3" />
              <h3 className="font-bold mb-1">Persönlich</h3>
              <p className="text-sm text-slate-600">Keine Massenabfertigung</p>
            </div>
            <div className="bg-emerald-50 p-6 rounded-2xl text-center">
              <div className="text-3xl font-bold text-emerald-600 mx-auto mb-3">0€</div>
              <h3 className="font-bold mb-1">Kostenlos</h3>
              <p className="text-sm text-slate-600">Für Bewerber</p>
            </div>
          </div>
        </div>

        {/* Location */}
        <div className="bg-slate-900 rounded-[40px] overflow-hidden shadow-2xl">
          <div className="grid md:grid-cols-2">
            <div className="p-12 md:p-16 flex flex-col justify-center text-white">
              <h2 className="text-3xl font-bold mb-4">Verwurzelt in Hamburg</h2>
              <p className="text-slate-300 mb-8 text-lg">
                Unser Büro liegt im Herzen von Hamburg. Von hier aus koordinieren wir die Vermittlung für die gesamte Metropolregion und angrenzende Bundesländer.
              </p>
              <div className="flex items-start gap-4 text-slate-300">
                <SafeIcon icon={FiMapPin} className="text-teal-500 text-xl mt-1 flex-shrink-0" />
                <div>
                  <strong className="text-white block mb-1">Nebenjob Nord</strong>
                  Axel-Springer-Platz 3<br />
                  20355 Hamburg
                </div>
              </div>
            </div>
            <div className="h-64 md:h-auto bg-slate-800 relative">
              {/* Image: Hamburg Skyline (Woman focused backdrop or generic) */}
              <img 
                src="https://images.unsplash.com/photo-1542840410-3092f99611a3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" 
                alt="Hamburg Speicherstadt" 
                className="w-full h-full object-cover opacity-80"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UeberUns;